"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.pageAndStationStyles = exports.helpText = void 0;
exports.helpText = {
    fontSize: "0.9em",
    color: "#999",
    fontStyle: "italic",
};
var pageAndStationTextShadow = {
    textShadow: "1px 3px 3px rgba(0, 0, 0, 0.8)",
};
exports.pageAndStationStyles = {
    header: {
        backgroundColor: "#0F7470",
        margin: 0,
    },
    headerBackground: {
        display: "flex",
        flexDirection: "column",
        padding: 16,
    },
    headerTitle: __assign({ fontSize: 32, marginBottom: 12, color: "white" }, pageAndStationTextShadow),
    subtitle: __assign({ fontSize: 14, marginBottom: 8, color: "white" }, pageAndStationTextShadow),
    textShadow: pageAndStationTextShadow,
    boldText: { fontWeight: "bold" },
};
exports.default = {
    helpText: exports.helpText,
};
